<template>
    <Modal
        title="Create New Event"
        :can-close-via-backdrop="false"
        @open="handleOpen"
    >
        <button
            type="button"
            class="
                ml-auto
                flex
                py-2
                px-4
                border
                font-bold
                border-accent
                rounded-full
                text-accent
                items-center
            "
        >
            <ion-icon name="add-outline" class="text-xl mr-2"></ion-icon>
            Create New Event
        </button>

        <template #body="{ close }">
            <form action="/calendar-events" method="post">
                <input type="hidden" name="_token" :value="$root.csrfToken" />
                <input type="hidden" name="teamId" :value="teamId" />
                <div class="my-2">
                    <label for="name" class="block font-semibold my-2 text-sm">
                        Title
                    </label>
                    <new-input
                        required
                        maxlength="128"
                        label="Name"
                        name="title"
                        placeholder="Event title"
                    ></new-input>
                </div>
                <div class="my-2">
                    <label
                        for="description"
                        class="block font-semibold my-2 text-sm"
                    >
                        Description (optional)
                    </label>
                    <new-textarea
                        label="Description (optional)"
                        name="description"
                        placeholder="Event Description (optional)"
                    ></new-textarea>
                </div>
                <div class="my-2">
                    <label
                        for="description"
                        class="block font-semibold my-2 text-sm"
                    >
                        Time
                    </label>
                    <new-input
                        type="datetime-local"
                        required
                        label="Time"
                        name="time"
                        placeholder="Time"
                        :value="state.datetimenow"
                    ></new-input>
                </div>
                <div class="my-2">
                    <label
                        for="room_id"
                        class="block font-semibold my-2 text-sm"
                    >
                        Meeting Room
                    </label>
                    <app-select
                        name="room_id"
                        model-value="-1"
                        @update:model-value="handleRoomChange"
                    >
                        <option value="-1" default selected>Offline</option>
                        <option
                            :value="room.room_id"
                            v-for="room in rooms"
                            :key="room.room_id"
                        >
                            {{ room.room_name }}
                        </option>
                    </app-select>
                </div>

                <div class="my-2" v-if="state.isOfflineRoom">
                    <label
                        for="description"
                        class="block font-semibold my-2 text-sm"
                    >
                        Location
                    </label>
                    <new-input
                        type="text"
                        required
                        label="Location"
                        name="location"
                        placeholder="Location"
                        value=""
                    ></new-input>
                </div>

                <div v-else class="flex items-center gap-2 my-4">
                    <MemberMultiselectInput
                        :current-users="[]"
                        :selected-users="state.members"
                        @select="addMember"
                        @remove="removeMember"
                    ></MemberMultiselectInput>
                </div>

                <div class="mt-8 flex items-center gap-4 justify-end">
                    <app-button
                        @click="close"
                        type="button"
                        class="border border-accent text-accent !bg-white"
                    >
                        Cancel
                    </app-button>
                    <app-button type="submit" class="!bg-primary text-white"
                        >Create Event</app-button
                    >
                </div>
            </form>
        </template>
    </Modal>
</template>
<script setup>
import { defineProps, reactive } from "vue";
import Modal from "./Modal";

const props = defineProps({
    rooms: {
        type: Array,
        required: true,
    },
    teamId: {
        type: Number,
        required: true,
    },
});

const state = reactive({
    datetimenow: new Date().toISOString().slice(0, 16),
    isOfflineRoom: true,
    members: [],
});

function addMember(member) {
    state.members.push(member);
}

function removeMember(member) {
    state.members = state.members.filter((m) => m.id !== member.id);
}

function handleOpen() {
    state.datetimenow = new Date().toISOString().slice(0, 16);
}

function handleRoomChange(e) {
    if (e == -1) {
        state.isOfflineRoom = true;
    } else {
        state.isOfflineRoom = false;
    }
}
</script>
